import { SET_ACTIVE_TAB_INCIDENT} from '../../actions/actionTypes';
export const setIncidentActiveTab= (tab)=>{
    return {
        type: SET_ACTIVE_TAB_INCIDENT,
        tab
    }
}